<template>
    <div class="accordion" id="orderAccordion">
        <div v-for="(order, index) in orders" class="card">
            <div data-toggle="collapse"
                 :data-target="'#collapse' + index"
                 aria-expanded="true"
                 :aria-controls="'collapse' + index"
                 class="card-header row d-flex justify-content-between align-items-center">
                <div class="col-12 col-md-4">
                    <h5 class="mb-0">
                        <i class="fa fa-fingerprint"></i> {{ order.order_number }}
                    </h5>
                </div>
                <div class="col">
                    <h5 class="mb-0">
                        <i class="fa fa-truck"></i> {{ order.status }}
                    </h5>
                </div>
				        <div class="col">
                    <h5 class="mb-0">
                        <i class="fa fa-sticky-note"></i> <span>{{ order.note }}</span>
                    </h5>
                </div>
                <div class="col">
                    <h5 class="mb-0">
                        <i class="fa fa-weight-hanging"></i> {{ order.sum_weight }}
                    </h5>
                </div>
                <div class="col">
                    <h5 class="mb-0">
                        <i class="fa fa-calendar"></i> {{ order.ts }}
                    </h5>
                </div>
                <div class="col">
                    <h5 class="mb-0">
                        <i class="fa fa-calendar"></i> ETA: {{ order.eta_delivery }}
                    </h5>
                </div>
            </div>
            <div :id="'collapse' + index" class="collapse" :aria-labelledby="'collapse' + index" data-parent="#orderAccordion">
                <div class="card-body">
                    <div class="mb-2">
                        <a v-bind:href="'/dashboard/orders-pdf/' + order.id" target="_blank" class="btn btn-outline-primary"><i class="fa fa-file-pdf"></i> <span class="d-none d-md-inline">Print as PDF</span></a>
                    </div>
                    <div class="row">
                        <div class="col-10 col-md-4">
                            <h5><i class="fa fa-map-marker-alt"></i> Address:</h5>
                            <p>{{ order.address }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <h5><i class="fa fa-sticky-note"></i> Note:</h5>
                            <p>{{ order.note }}</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <h5><i class="fa fa-truck"></i> Order status:</h5>
                            <p>{{ order.status }}</p>
                        </div>
                        <div class="col-12">
                            <div v-for="(product, p_index) in order.products" class="card">
                                <div class="card-header bg-white d-flex justify-content-between align-items-center">
                                    <div class="col-12 col-md-3">
                                        <span class="text-dark">
                                            <i class="fa fa-fingerprint"></i> {{ product.order_code }} {{ product.name }}
                                        </span>
                                    </div>
									<div class="col-12 col-md-3">
                                        <span class="text-dark">
                                            <i class="fa fa-sticky-note"></i> {{ product.order_note }}
                                        </span>
                                    </div>
                                   <div class="col-12 col-md-3">
                                        <span class="text-dark">
                                            <i class="fa fa-euro-sign"></i> {{ product.customer_price }}
                                        </span>
                                    </div>
                                    <div class="col">
                                        <span class="text-dark">
                                            <i class="fa fa-infinity"></i> {{ product.quantity }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            open: null,
        }
    },
    methods: {
        getOrderProducts(order_number) {
        }
    },
    props: {
        orders: Array
    },
    mounted() {
        console.log(this.orders);
    }

}
</script>
<style scoped>
.col{
    padding-left: 5px;
    padding-right: 5px;
}
#img-focused{
    max-height: 45vh;
}
</style>


